
export const reminderEndpoints = {
    getReminder: '/api/Reminder/',
    deleteReminder: '/api/Reminder/Delete',
    postInsertReminder: '/api/Reminder/Insert',
    postFilterReminder: '/api/Reminder/Filter',
    postUploadReminder: '/api/Reminder/Upload',
    UpdateReminder: '/api/Reminder/Update',
};